import { computed, Injectable, signal } from "@angular/core";
import { ProfileStateModel } from "../Dto/ProfileStateModel";
import { UserListItem } from "../Dto/UserModel";

const initialState: ProfileStateModel = {
  profile: null,
  loading: false,
  error: null,
};

@Injectable({ providedIn: "root" })
export class ProfileState {
  private readonly state = signal<ProfileStateModel>(initialState);

  public readonly profile = computed(() => this.state().profile);
  public readonly loading = computed(() => this.state().loading);
  public readonly error = computed(() => this.state().error);

  setProfile(profile: UserListItem | null): void {
    this.state.update((state) => ({
      ...state,
      profile,
      loading: false,
      error: null,
    }));
  }

  setLoading(loading: boolean): void {
    this.state.update((state) => ({ ...state, loading }));
  }

  setError(error: string | null): void {
    this.state.update((state) => ({ ...state, error, loading: false }));
  }
}
